import { PaginatorStatus } from './../../components/generics/data-table/data-table.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Property } from 'src/app/models/property.model';
import { UtilsService } from '../../services/utils.service';
import { ErrorResponse } from '../../models/error.model';
import { OwnersService } from 'src/app/services/owners.service';
import { PropertiesService } from 'src/app/services/properties.service';
import { Owner } from 'src/app/models/owner.model';
import { getOwnerName } from '../../models/owner.model';
import { ID } from 'src/app/models/ID.model';

@Component({
    selector: 'app-property-selector-dialog',
    templateUrl: './property-selector-dialog.component.html',
    styleUrls: ['./property-selector-dialog.component.scss']
})
export class PropertySelectorDialogComponent implements OnInit {

    getOwnerName = getOwnerName;

    filtersFG = new UntypedFormGroup({
        propietario: new UntypedFormControl(undefined),
        direccion: new UntypedFormControl(undefined),
        codigo: new UntypedFormControl(undefined),
    });

    paginatorStatus: PaginatorStatus = {
        page: 0,
        itemsPerPage: 30,
        totalElementCount: 0
    };

    properties?: Property[];
    owners?: Owner[];

    constructor(
        private ownersService: OwnersService,
        private propertiesService: PropertiesService,
        private dialogRef: MatDialogRef<PropertySelectorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { idAgente: ID },
        public utilsService: UtilsService,
    ) { }

    ngOnInit(): void {
        this.filtersFG.controls.propietario.valueChanges.subscribe(value => {
            if (typeof value !== 'string') return;
            this.ownersService.searchOwner(value).subscribe(owners => {
                this.owners = owners;
            }, (error: ErrorResponse) => this.utilsService.alert('Error buscando propietarios', error.error?.descripcion));
        });
        this.getProperties();
    }

    cerrarDialogo(property?: Property | undefined) {
      this.dialogRef.close(property);
    }

    displayOwner(owner: Owner | string) {
        if (typeof owner === 'string') {
            return owner;
        } else {
            return owner ? getOwnerName(owner) : '';
        }
    }

    getProperties() {
        const value = this.filtersFG.getRawValue();
        const filters: any = {};
        if (this.data?.idAgente)
            filters['id-agente'] = this.data.idAgente;
        if (value.propietario && typeof value.propietario !== 'string')
            filters['propietario-id'] = value.propietario.id;
        if (value.direccion)
            filters.direccion = value.direccion;
        if (value.codigo)
            filters.codigo = value.codigo;
        this.properties = undefined;
        this.propertiesService.getProperties(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage, [], filters).subscribe(response => {
            this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
            this.properties = response.body;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener propiedades', error.error?.descripcion));
    }

}
